var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var _a;
// Map to convert Greek characters into Latin ones.
// Based on the greekToTransliteratedLatinMap map in this library: https://github.com/vbarzokas/greek-utils/
/* eslint-disable no-useless-computed-key */
var greekToLatin = (_a = {},
    _a['α'] = 'a',
    _a['β'] = 'v',
    _a['γ'] = 'g',
    _a['δ'] = 'd',
    _a['ε'] = 'e',
    _a['ζ'] = 'z',
    _a['η'] = 'ē',
    _a['θ'] = 'th',
    _a['ι'] = 'i',
    _a['κ'] = 'k',
    _a['λ'] = 'l',
    _a['μ'] = 'm',
    _a['ν'] = 'n',
    _a['ξ'] = 'x',
    _a['ο'] = 'o',
    _a['π'] = 'p',
    _a['ρ'] = 'r',
    _a['σ'] = 's',
    _a['ς'] = 's',
    _a['τ'] = 't',
    _a['υ'] = 'u',
    _a['φ'] = 'ph',
    _a['χ'] = 'kh',
    _a['ψ'] = 'ps',
    _a['ω'] = 'ō',
    _a['ά'] = 'á',
    _a['έ'] = 'é',
    _a['ί'] = 'í',
    _a['ό'] = 'ó',
    _a['ύ'] = 'ú',
    _a['ή'] = 'ḗ',
    _a['ώ'] = 'ṓ',
    _a['ϊ'] = 'ï',
    _a['ϋ'] = 'ü',
    _a['ΰ'] = 'ǘ',
    _a['ΐ'] = 'ḯ',
    _a['Α'] = 'A',
    _a['Β'] = 'V',
    _a['Γ'] = 'G',
    _a['Δ'] = 'D',
    _a['Ε'] = 'E',
    _a['Ζ'] = 'Z',
    _a['Η'] = 'Ē',
    _a['Θ'] = 'Th',
    _a['Ι'] = 'I',
    _a['Κ'] = 'K',
    _a['Λ'] = 'L',
    _a['Μ'] = 'M',
    _a['Ν'] = 'N',
    _a['Ξ'] = 'X',
    _a['Ο'] = 'O',
    _a['Π'] = 'P',
    _a['Ρ'] = 'R',
    _a['Σ'] = 'S',
    _a['Τ'] = 'T',
    _a['Υ'] = 'U',
    _a['Φ'] = 'Ph',
    _a['Χ'] = 'Kh',
    _a['Ψ'] = 'Ps',
    _a['Ω'] = 'Ō',
    _a['Ά'] = 'Á',
    _a['Έ'] = 'É',
    _a['Ί'] = 'Í',
    _a['Ό'] = 'Ó',
    _a['Ύ'] = 'Ú',
    _a['Ή'] = 'Ḗ',
    _a['Ώ'] = 'Ṓ',
    _a['Ϊ'] = 'Ï',
    _a['Ϋ'] = 'Ü',
    _a[';'] = '?',
    _a);
/* eslint-enable no-useless-computed-key */
/**
 * Takes an array of SearchCriteria items and filter them out by the query
 * Converts
 * @param criteria
 * @param query
 */
var filterBySearchQuery = function (query, criteria) {
    if (!criteria || !query)
        return [];
    var activeQuery = query.split('').map(function (char) {
        if (char in greekToLatin) {
            return greekToLatin[char];
        }
        return char;
    }).join('').toLowerCase();
    return __spreadArray([], criteria).filter(function (_a) {
        var title = _a.title;
        return (title
            // First convert the Greek titles to phonetic latin equivalent
            .split('')
            .map(function (char) {
            if (char in greekToLatin) {
                return greekToLatin[char];
            }
            return char;
        })
            .join('')
            .toLowerCase()
        // Then check if title includes the query
        ).includes(activeQuery.toLowerCase());
    });
};
export default filterBySearchQuery;
